import React from "react";
import { MdOutgoingMail } from "react-icons/md";
import { FaPaperPlane, FaTimes } from "react-icons/fa";

import ModalShell from "./ModalShell";

function ComposeMessageModal({
  mode = "new",
  subject,
  content,
  onSubjectChange,
  onContentChange,
  onSend,
  onClose,
  sending,
  t,
}) {
  const isReply = mode === "reply";

  return (
    <ModalShell
      title={
        isReply
          ? t("messagerie.responseMessage", {
              defaultValue: "Répondre au message",
            })
          : t("messagerie.adminMessage", {
              defaultValue: "Nouveau message",
            })
      }
      eyebrow={isReply ? "Réponse" : "Messagerie"}
      onClose={onClose}
    >
      <div className="mb-5 flex items-center gap-3 rounded-[1.5rem] border border-slate-200 bg-slate-50 p-4 dark:border-white/10 dark:bg-white/[0.05]">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-sky-100 text-sky-700 dark:bg-sky-500/10 dark:text-sky-200">
          <MdOutgoingMail className="text-2xl" />
        </div>

        <div>
          <p className="font-titre text-lg font-bold text-slate-950 dark:text-white">
            {isReply ? "Votre réponse" : "Message à l’administration"}
          </p>
          <p className="mt-1 text-sm font-medium text-slate-500 dark:text-white/50">
            Le sujet et le contenu sont obligatoires.
          </p>
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <label className="mb-2 block text-sm font-bold text-slate-700 dark:text-white/80">
            Sujet
          </label>

          <input
            type="text"
            value={subject}
            onChange={(event) => onSubjectChange(event.target.value)}
            placeholder="Sujet du message"
            className="min-h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-semibold text-slate-900 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-500/10 dark:border-white/10 dark:bg-white/[0.06] dark:text-white"
          />
        </div>

        <div>
          <label className="mb-2 block text-sm font-bold text-slate-700 dark:text-white/80">
            Message
          </label>

          <textarea
            value={content}
            onChange={(event) => onContentChange(event.target.value)}
            placeholder="Votre message..."
            className="min-h-40 w-full resize-none rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-semibold leading-6 text-slate-900 outline-none transition focus:border-sky-400 focus:bg-white focus:ring-4 focus:ring-sky-500/10 dark:border-white/10 dark:bg-white/[0.06] dark:text-white"
          />
        </div>
      </div>

      <div className="mt-6 flex flex-col-reverse gap-3 border-t border-slate-200 pt-5 dark:border-white/10 sm:flex-row sm:justify-end">
        <button
          type="button"
          onClick={onClose}
          className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-white/10 dark:bg-white/[0.06] dark:text-white dark:hover:bg-white/10"
        >
          <FaTimes />
          {t("messagerie.btnAnnuler", { defaultValue: "Annuler" })}
        </button>

        <button
          type="button"
          onClick={onSend}
          disabled={sending}
          className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-blue-600 to-orange-500 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-orange-500/20 transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <FaPaperPlane />
          {sending
            ? "Envoi..."
            : t("messagerie.btnEnvoyer", { defaultValue: "Envoyer" })}
        </button>
      </div>
    </ModalShell>
  );
}

export default ComposeMessageModal;